import { get } from 'lodash';
// import {QueryRaisedService} from "../components/QueryRaised/api/services";
// import {downloadPDF} from "../components/ApplyLicense/dependencies/utils/index"
export const debounce = (fn, delay) => {
    let timeoutId;
    return function (...args) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            clearTimeout(timeoutId);
            timeoutId = null;
            fn(...args);
        }, delay);
    };
}

export const sortArray = (data) => {
    return data.sort(function (a, b) {
        if (a.serialNo < b.serialNo) return -1;
        if (a.serialNo > b.serialNo) return 1;
        return 0;
    });
};
export const lazyRetry = (componentImport) => {
      return new Promise((resolve, reject) => {
        componentImport().then(resolve).catch((error) => {
          console.error('Failed to load chunk, retrying...', error);
          window.location.reload();
        });
      });
    };
export const getQuestionOption = (searchKey, question) => {
    const options = sortArray(get(question, 'responses', []));
    if (question.id === get(searchKey, 'questionId') && options && options.length > 4) {
        const _options = options.filter(x => get(x, 'description', '').toLowerCase().indexOf(get(searchKey, 'text', '').toLowerCase()) > -1);
        return _options;
    } else {
        return options
    }
}

export const checkFieldType = (fieldType) =>{
    return fieldType === 'ADDRESS'|| fieldType === 'ADDRESS_1' || fieldType === 'ADDRESS_2' || fieldType === 'COUNTRY' || fieldType === "CITY" || fieldType === "STATE" || fieldType === "PIN_CODE" || fieldType === "TEHSIL" || fieldType === "LANDMARK" || fieldType === "POST_OFFICE" || fieldType === 'Address 1' || fieldType === 'Address 2' || fieldType === 'Country' || fieldType === "City" || fieldType === "State" || fieldType === "Pin Code" || fieldType === "Tehsil" || fieldType === "Landmark" || fieldType === "Post Office" || fieldType === "FIELD_GROUP" || fieldType === 'MASTER_DATA'
}

export const checkAddressSubField = (fieldType) =>{
     return
}

export const getLink = (inputText)=> {
    let replacedText, replacePattern1, replacePattern2;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText && inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText && replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    return replacedText;
};

export const numberWithCommas = (x=0) => {
    return x.toString().split('.')[0].length > 3 ? x.toString().substring(0,x.toString().split('.')[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length-3): x.toString();
};

export const getFieldAttrValue = (fieldAttrObj,fieldOption) =>{
    if(fieldOption === 'properties') {
        let value = fieldAttrObj.filter((item) => item.name.replace(/_/g, "").toLowerCase() !== 'hint' && item.name.replace(/_/g, "").toLowerCase() !== 'mandatory' && item.name.replace(/_/g, "").toLowerCase() !== 'fieldsize' && item.name.toLowerCase()!== 'additional_validation');
        return value;
    }else if(fieldOption === 'allowFileType'){
        let value = fieldAttrObj.filter((item) => item.name.replace(/_/g, "").toLowerCase() !== 'hint' && item.name.replace(/_/g, "").toLowerCase() !== 'mandatory' && item.name.replace(/_/g, "").toLowerCase() !== 'fieldsize' && item.name !== 'MAX_FILE_SIZE' && item.name !== 'MAX_NO_OF_FILE' && item.name.toLowerCase()!== 'additional_validation');
        let valueArr=[];
        value.map((item)=>{if(item.value === 'true')valueArr.push(item.name)})
        return valueArr;
    } else{
        let value = fieldOption === 'DATE_AND_TIME' || fieldOption === 'ONLY_DATE' || fieldOption === 'ONLY_TIME' || fieldOption === "MAX_NO_OF_FILE" || fieldOption === "MAX_FILE_SIZE" || fieldOption === "ADDITIONAL_VALIDATION" ?
            fieldAttrObj.filter((item) => {
               return  item.name === fieldOption
            }):
            fieldAttrObj.filter((item) => item.name.replace(/_/g, "").toLowerCase() === fieldOption);
        if (value.length)
            return value[0];
    }
    return {value:''}
}

export const pdfBlobConversion = (b64Data, contentType) => {
    contentType = contentType || '';
    let sliceSize = 512;
    b64Data = b64Data && b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data && b64Data.replace(/\s/g, '');
    let byteCharacters = window.atob(b64Data);
    let byteArrays = [];
    for ( let offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const getFileExtensionOfFile = (fileName) => {
    return fileName && fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2)
};

export const filterDashboardData = (data,filterText)=>{
    let newData = [];
    newData = data.filter((item) => (item?.fileName?.toLowerCase().includes(filterText) ||
        item?.fileTitle?.toLowerCase().includes(filterText) ||
        item?.documentName?.toLowerCase().includes(filterText) ||
        item?.fieldName?.toLowerCase().includes(filterText)) ||
        item?.name?.toLowerCase().includes(filterText) ||
        item?.licence?.toLowerCase().includes(filterText) ||
        item?.organizationName?.toLowerCase().includes(filterText));
    return newData
}

const passDocSearch = (item, filterText) => {
    return (item?.fileName?.toLowerCase().includes(filterText) ||
    item?.fileTitle?.toLowerCase().includes(filterText) ||
    item?.documentName?.toLowerCase().includes(filterText) ||
    item?.fieldName?.toLowerCase().includes(filterText) ||
    item?.name?.toLowerCase().includes(filterText) ||
    item?.licence?.toLowerCase().includes(filterText) ||
    item?.organizationName?.toLowerCase().includes(filterText))
}

export const filterUploadedDocumentData = (allDocumentsData,filterText)=> {
        let latestDocs = allDocumentsData.filter(item => item.isLatestVersion === 'Y' && passDocSearch(item, filterText))
        let sortedDocsByDate = latestDocs && latestDocs.length > 0 ?
            latestDocs.sort(function(a, b){return new Date(b.uploadedDate) - new Date(a.uploadedDate);}) : [];
        return sortedDocsByDate || []
}

export const dynamicSort = (data, sortFeild= 'serialNo') => (
    data.sort(function (a, b) {
        if (get(a,sortFeild) < get(b,sortFeild)) return -1;
        if (get(a,sortFeild) > get(b,sortFeild)) return 1;
        return 0;
    })
);

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export function  downloadFiles(val){
    // if (val) {
    //     const param = {
    //         contentId: [...val]
    //     };

    //     return QueryRaisedService.getFile(param).then((res) => {
    //         const {data = {}} = res;
    //         if (data.response && data.response instanceof Array && data.response.length > 0) {
    //             data.response.forEach((val) => {
    //                 let {fileName, fileResponse, fileURL} = val;
    //                 const _type = fileName && fileName.split('.').pop();
    //                 const param = {data:fileResponse, fileName:fileName,type: _type, fileURL:fileURL}
    //                 // downloadPDF(param);
    //             })
    //         }

    //     }).catch((e) => {
    //         return false;
    //     })
    // }
};